import { cn } from '@/lib/utils'
import type { PropsWithChildren } from 'react'
import { isBrowser } from 'react-device-detect'
import { useIsStuck } from './use-is-stuck'

const MOBILE_HEADER_HEIGHT = 78

interface StickyFiltersProps extends PropsWithChildren {
  className?: string
}

/** Pins a page's filter card to the top of the viewport while scrolling. */
export const StickyFilters: React.FC<StickyFiltersProps> = ({
  children,
  className,
}) => {
  const topOffset = isBrowser ? 0 : MOBILE_HEADER_HEIGHT
  const { sentinelRef, stuck } = useIsStuck<HTMLDivElement>(topOffset)

  return (
    <>
      <div ref={sentinelRef} aria-hidden />

      <div
        data-stuck={stuck || undefined}
        className={cn(
          'md:sticky md:z-30',
          '*:transition-[border-radius,box-shadow]',
          '[&[data-stuck]>*]:rounded-t-none [&[data-stuck]>*]:shadow-[0_12px_24px_-12px_#00305740]',
          className
        )}
        style={{ top: topOffset }}
      >
        {children}
      </div>
    </>
  )
}
